import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { View } from '@react-pdf/renderer';
import CardItem from './CardItem';
import Header from './Header';
import SelectionsLabel from './SelectionsLabel';
const SelectedItemsPage = ({ selectedItemsList, isVariant, }) => (_jsxs(View, { children: [_jsx(Header, {}), _jsx(SelectionsLabel, {}), selectedItemsList === null || selectedItemsList === void 0 ? void 0 : selectedItemsList.map(item => (_jsx(CardItem, { item: item, isVariant: isVariant }, item.id)))] }));
export default SelectedItemsPage;
